import React from 'react';
import { Patient } from '@/types/Patient';
import { ProcedureStep } from '@/types/ProcedureStep';
import { CSSProperties, Fragment } from 'react';
import Box from '@material-ui/core/Box';
import ProcedureStepTime from '@/components/pages/kiosk/tablet/v2/ProcedureStepTime';
import Divider from '@material-ui/core/Divider';

type ProcedureStepsColumnProps = {
  steps: (ProcedureStep & { highlight: boolean; show: boolean })[];
  patient?: Patient & { duration?: string };
  isPreviousPatient: boolean;
  containerStyle?: CSSProperties;
};

export const ProcedureStepsColumn = ({
  steps,
  patient,
  isPreviousPatient,
  containerStyle,
}: ProcedureStepsColumnProps) => (
  <Box style={containerStyle}>
    {steps.map((procedureStep, index) => (
      <Fragment key={procedureStep?.id ?? index}>
        <Box style={{ flex: 1 }}>
          <ProcedureStepTime
            key={procedureStep?.id}
            index={index}
            procedureStep={procedureStep}
            patient={patient}
            isPreviousPatient={isPreviousPatient}
          />
        </Box>
        {index + 1 < steps.length && <Divider />}
      </Fragment>
    ))}
  </Box>
);
